import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { Autofill } from '@fluentui/react/lib/Autofill';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { TimeZoneFloatingPicker } from 'owa-time-zone-picker';
import useClockViewPickerViewState from '../viewstate/useClockViewPickerViewState';

export default observer(function ClockViewPicker() {
    const { inputProps, pickerProps } = useClockViewPickerViewState();

    return (
        <div className={styles.addCityContainer}>
            <Icon className={styles.addCityIcon} iconName={ControlIcons.Add} />
            <Autofill className={styles.addCityInput} {...inputProps} />
            <TimeZoneFloatingPicker {...pickerProps} />
        </div>
    );
});
